<template lang="html">
    <div title="Détails du produit" class="product-aside"  v-if="product">
        <div class="contain product-detail-header-container">
            <div class="top">
                 <upload-avatar :defaultImg="require('../../../assets/img/defaultProduct.png')" :item="product" :item-id="product.id" :store-key="product.type + '_products[' + params.product_index + '].photo'" entities="products" field="photo"></upload-avatar>
            </div>
            <div class="name">
                <h2><a @click.stop="goToProduct(product.id, product.group)">{{product.label}}</a></h2>
                <p v-if="product.supplier">{{product.supplier.name}}</p>
                <span v-if="product.category && product.category.parent">
                    {{product.category.parent.label}}
                </span>
            </div>
        </div>
        <div class="tab product-details-tab">
			<v-tabs grow fixed centered slider-color="primary" :show-arrows="true" @input="scrollBottomComments">
                <v-tab :href="'#specs'" ripple>Informations</v-tab>
                <v-tab :href="'#comments'" ripple v-if="comments">Commentaires</v-tab>

                <!-- #region -- tab Informations -->
                <v-tab-item :id="'specs'" :key="'specs'">
                    <div class="tab-title">
                        <p>
                            A propos
                        </p>
                    </div>
                    <div class="specs-container">
                        <div class="field" data-group="1">
                            <div class="label">Type de produit</div>
                            <div class="value"> {{productTypeLabel}}</div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Produit</div>
                            <div class="value" v-if="product.type != 'sidamo'">
                                <a @click.stop="goToProduct(product.id, product.group)">{{product.label}}</a>
                            </div>
                            <div class="value" v-else>
                                <a @click.stop="goToProduct(product.id, product.group)">{{product.label}}</a>
                            </div>
                        </div>
                        <div class="field" data-group="1" v-if="product.type != 'sidamo'">
                            <div class="label">Lien externe</div>
                            <div class="value">
                                <a :href="product.external_link" v-if='product.external_link'>Ouvrir le lien</a>
                                <template v-else> - </template>
                            </div>
                        </div>
                        <div class="field" data-group="1" v-else>
                            <div class="label">Code</div>
                            <div class="value">
                                {{product.code}}
                            </div>
                        </div>

                    </div>
                    <div class="tab-title mt-3">
                        <p>
                            Caractéristiques Techniques
                        </p>
                    </div>
                    <div class="specs-container">
                        <div class="field mb-1" data-group="1" v-for="field in fields" :key="field.id">
                            <div class="label">
                                {{field.label}}
                            </div>
                            <div class="value" v-if="field.pivot">
                                {{field.pivot.value}}
                            </div>
                        </div>
                    </div>
                </v-tab-item>
                <!-- #endregion -->

                <!-- #region -- tab Commentaires -->
                <v-tab-item :id="'comments'" :key="'comments'" class="comments-container" v-if="comments">
                    <div class="tab-title">
                        <p>
                            {{comments.length}} {{comments.length | pluralize('Commentaire')}}
                        </p>
                        <v-menu>
                            <div slot="activator">
                                <v-icon flat>more_horiz</v-icon>
                            </div>
                            <v-list>
                                <v-list-tile @click="createComment(product,true)" class="li">
                                    Ajouter un commentaire
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-layout column >
                        <v-flex class="comment" v-for="comment in comments" :key="comments.id">
                            <v-layout justify-center align-content-center>
                                <v-flex xs2 class="mx-2">
                                    <v-layout>
                                        <avatar :item="comment.user" v-if="comment.user"></avatar>
                                        <v-icon class="comment-type" :style="{color: getCommentColor(comment.type)}">fiber_manual_record</v-icon>
                                    </v-layout>
                                </v-flex>
                                <v-flex>
                                    <p class="mb-0">
                                        {{comment.title}}
                                    </p>
                                    <p class="mb-2 grey--text">
                                        {{comment.message}}
                                    </p>
                                    <p class="comment-date mb-0">
                                        {{moment(comment.updated_at).format('DD/MM/YYYY h:mm')}}
                                    </p>
                                </v-flex>
                              <v-flex xs1>
                                <v-menu v-if="user_id === comment.user_id">
                                  <div slot="activator">
                                    <v-icon flat>more_horiz</v-icon>
                                  </div>
                                  <v-list>
                                    <v-list-tile @click="createComment(product)" class="li">
                                      Modifier...
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
                <!-- #endregion -->

			</v-tabs>
		</div>
    </div>
    <div v-else></div>
</template>

<script>
import { ProductTypes } from '../../../config/enum/ProductTypes'
import { CommentTypes } from '../../../config/enum/CommentTypes'
import UploadAvatar from '../../../components/avatar/UploadAvatar.vue'
import Avatar from '../../../components/avatar/Avatar.vue'
import CreateComment from '../../products/single/CreateComment'
import moment from 'moment'

export default {
    components: {UploadAvatar, Avatar, CreateComment},
    props: {
        params: {
          required: false
        }
    },
    data() {
        return {
            moment,
            CreateComment
        }
    },
    computed: {
        productTypeLabel: function () {
          return ProductTypes.find((el) => {
            return el.value === this.product.type
          }).label;
        },

        comments: function () {
            if(this.product.comments) {
                return this.product.comments.sort((a, b) => a.created_at > b.created_at);
            }
        },

        product: function () {
          if (this.params.product_type !== null && this.params.product_index !== null) {
            return this.$store.state.single.data[this.params.product_type + '_products'][this.params.product_index];
          }
        },

        user_id: function() {
          return this.$store.state.auth.user.id
        },

        fields() {
            let fields = this.product.fields
            return this.$_.orderBy(fields, f => {
                return f.pivot.position
            })
        }

    },
    methods: {
        goToProduct: function (productId, groupLabel) {
          this.$router.push({name: 'single-product', params: {id: productId, group: groupLabel}})
        },

        getCommentColor: function (type) {
          let commentType = CommentTypes.find((el) => {
            return el.value === type
          });
          return commentType ? commentType.color : '';
        },

        goToComments(productId, groupLabel) {
              this.$router.push({name: 'product-comments', params: {id: productId, group: groupLabel}})
        },

        createComment(product,create = false) {
            this.$eventHub.$emit('open-modal', CreateComment, {
                product_id : product.id,
                product_label: product.label,//this.$store.state.single.data.label
                element_type: 'comment',
                create_query: create,
                hide_demand: true,
                store_path: this.params.product_type + '_products['+this.params.product_index+'].comments'
            })
        },

        open() {
          this.$refs.modal.open()
        },

        scrollBottomComments() {
          var element = document.getElementById("comments");
          if(element) {
              element.scrollTop = element.scrollHeight;
          }
        }
    },
}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/main.styl'
    @require '../../../assets/css/variables.styl'


    .product-aside {
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
        height: calc(100% - 2rem)
        .top >>> .avatar {
            margin-top:-2rem!important
            font-size: 3rem!important
        }
        .name {
            padding: 0 1.5rem
            h2 {
                margin-top: 2rem
                font-size: 2rem
                font-weight: 700
                color: $text-color
                a{
                    color: $text-color
                    text-decoration: none
                }
            }
            p {
                color: #707D90
                font-weight: 500
                font-size: 1.6rem
                margin-bottom: 0
                text-decoration: none
            }
            span {
                color: #D4DCE5
                font-size: 1.5rem
                font-weight: 500
                display: block
            }
        }

        .tab {
            height: 100%
            .tabs {
                height: 100%
                .tabs__bar {
                    margin-bottom : 20px
                    & >>> .tabs__li a{
                        text-transform: none
                        color: $text-color
                        font-size: 1.5rem
                        font-weight: 700
                        &.tabs__item--active {
                            color: $primary-color !important
                        }
                    }
                }
                & >>> .tabs__items {
                    overflow-y: scroll
                    height: 100%
                    padding-bottom: 20rem
                }
            }
        }

        .tab-title {
            padding:10px
            display:flex
            flex-direction:row
            align-items:center
            justify-content:space-between

            p {
                color:#ABABAB
                font-weight:700
                margin-bottom:0px
            }
        }

        .specs-container {
            overflow-y:auto
            height:100%

            .field {
                padding: 0 1.5rem
                display: flex
                align-items: center
                margin-bottom: 1.5rem!important

                .label {
                    flex:1
                    text-align: left
                    margin-right: 1rem
                }
                .value {
                    flex: 1
                    display: flex
                    align-items: center
                    min-height: 2rem
                    font-size: 1.4rem
                    font-weight: 600
                    color:$primary-color
                    overflow: hidden
                    word-break: break-all
                    a {
                        color:$primary-color
                        text-decoration: underline
                    }
                    &.logo {
                        display: flex
                        justify-content: space-between
                        align-items: center
                        padding: 0 0.5rem
                        span {
                            display: flex
                            flex-direction: row
                            align-items: center
                            .avatar{
                                margin-right: 1rem
                            }
                        }
                        .avatar{
                            margin-top: 0
                        }
                    }

                    .btn--icon.edit {
                        opacity: 0
                    }

                    &:hover {
                        .btn--icon.edit {
                            opacity: 1
                            color: #abb4d0
                        }
                    }
                    .btn--icon.edit {
                        &:focus {
                            opacity : 1
                            color: #abb4d0
                        }
                    }

                    &.area {
                        position: relative
                        padding: 0 0.5rem

                        .icon {
                            transition: opacity ease-out 300ms
                            position: absolute
                            top: 0.5rem
                            right: 0.5rem
                            color: #ABB4D0
                            font-size: 1.6rem
                            opacity: 0
                        }

                        &:hover {
                            cursor: pointer
                            background-color: $app-content-background

                            .icon {
                                opacity: 1
                            }
                        }
                    }
                }
            }


        }

        .comments-container {
            overflow-y:auto
            height:60vh

            .comment {
                flex-shrink: 0
                padding:10px
                border-bottom: solid 1px rgba(0,0,0,0.12)

                .comment-date {
                    color:$primary-color
                    font-weight:700
                }

                .flex > .menu {
                  display:flex!important
                  height:100%
                  opacity:0
                  transition: opacity ease-in-out 0.5s

                  & >>> .menu__activator {
                    margin:auto
                  }

                }

                &:hover {
                  .flex > .menu {
                    opacity:1
                  }
                }


            }
        }

        .product-detail-header-container {
            text-align: center
        }


        .comment-type {
            margin-left: -20px
            margin-top: 30px
        }

        .fields-label {
            margin:10px
            .fields-label-code {
                margin-left:20px
            }
        }

        .actions-button {
            position:absolute
            bottom:0px
            right:0px
            height:100px
        }

    }





</style>



// WEBPACK FOOTER //
// src/views/projects/single/ProductAside.vue